import React from 'react';
import AdminTable from 'layouts/AdminTable';
import FormTextInput from 'components/FormTextInput/FormTextInput';
import FormImageUpload from 'components/FormImageUpload/FormImageUpload';
import FormControlButtons from 'components/FormControlButtons/FormControlButtons';
import Check from '@material-ui/icons/Check';
import Checkbox from '@material-ui/core/Checkbox';
import FormLabel from '@material-ui/core/FormLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { useTranslation } from 'react-i18next';
import SEOSettingsCms from 'views/SEO/SEOSettingsCms';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';

import TextFieldTooltip from './Tooltip';

const DietDelivery = ({
  classes,
  getImage,
  removeImage,
  bannerTitle,
  handleToggle,
  handleSubmit,
  bannerMobile,
  bannerDesktop,
  allowedToModify,
  pageDescription,
  handleInputChange,
  bannerInfoEnabled,
  bannerDescription,
  allowToModifyFiltering,
  modules,
  setModules,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <AdminTable
        title={t('form.menuPlanning.subpageSettings')}
        isMarginLeft={true}
      >
        <FormTextInput
          label={t('module.MenuPage.pageDescription')}
          classes={classes}
          name="pageDescription"
          value={pageDescription}
          handleChange={handleInputChange}
          inputSize={12}
          maxLength={255}
        />
        <FormControlLabel
          control={
            <Checkbox
              name="bannerInfoEnabled"
              onClick={handleToggle}
              checked={!!bannerInfoEnabled}
              checkedIcon={<Check className={classes.checkedIcon} />}
              icon={<Check className={classes.uncheckedIcon} />}
              classes={{
                checked: classes.checked,
                root: classes.checkRoot,
              }}
            />
          }
          label={t('form.menuPlanning.showInfoBanner')}
        />
        {bannerInfoEnabled && (
          <>
            <FormTextInput
              multiline={true}
              rows={3}
              rowsMax={10}
              label={
                <TextFieldTooltip
                  label={t('form.menuPlanning.headerInBanner')}
                />
              }
              classes={classes}
              name="bannerTitle"
              value={bannerTitle}
              handleChange={handleInputChange}
              inputSize={10}
              maxLength={160}
            />
            <FormTextInput
              label={
                <TextFieldTooltip
                  label={t('form.menuPlanning.textUnderCaption')}
                />
              }
              classes={classes}
              name="bannerDescription"
              value={bannerDescription}
              handleChange={handleInputChange}
              inputSize={10}
              maxLength={1000}
              rows={3}
              rowsMax={20}
              multiline={true}
            />

            <div
              style={{
                display: 'flex',
                justifyContent: 'space-around',
                textAlign: 'center',
              }}
            >
              <div>
                <FormLabel
                  className={classes.labelHorizontal}
                  style={{ marginTop: '15px', marginBottom: '24px' }}
                >
                  {t('form.menuPlanning.bannerForDesktop')}
                </FormLabel>
                <FormImageUpload
                  stateName="bannerDesktop"
                  buttonText={t('common.shared.select')}
                  getImage={getImage}
                  imgId="desktop-banner"
                  tooltipImageSize={t('form.menuPlanning.tooltipImageDesktop')}
                  removeImage={removeImage}
                  previewUrl={bannerDesktop?.contentUrl}
                />
              </div>
              <div>
                <FormLabel
                  className={classes.labelHorizontal}
                  style={{ marginTop: '15px', marginBottom: '24px' }}
                >
                  {t('form.menuPlanning.bannerMobile')}
                </FormLabel>
                <FormImageUpload
                  stateName="bannerMobile"
                  buttonText={t('common.shared.select')}
                  getImage={getImage}
                  imgId="mobile-banner"
                  tooltipImageSize={t('form.menuPlanning.tooltipImageMobile')}
                  removeImage={removeImage}
                  previewUrl={bannerMobile?.contentUrl}
                />
              </div>
            </div>
          </>
        )}
      </AdminTable>
      {!isEmpty(modules) && (
        <SEOSettingsCms
          state={modules}
          setState={setModules}
          classes={classes}
          section="SeoCmsMenuSubpage"
        />
      )}
      {(allowToModifyFiltering || !isEmpty(modules) || allowedToModify) && (
        <FormControlButtons
          classes={classes}
          submitText={t('form.save')}
          handleSubmit={handleSubmit}
        />
      )}
    </>
  );
};

const enhance = compose(
  connect(({ Auth: { selectedBrand } }) => ({
    selectedBrand,
  }))
);

export default enhance(DietDelivery);
